<script>
import EmployeeDashboardView from "@/views/Dashboard/EmployeeDashboardView.vue";
import EmployerDashboardView from "@/views/Dashboard/EmployerDashboardView.vue";
import AdminDashboardView from "@/views/Dashboard/AdminDashboardView.vue";

export default {
    data() {
        return {
            component: null,
        }
    },
    mounted() {
        if (this.$auth.isEmployer()) {
            this.component = EmployerDashboardView;
        } else if (this.$auth.isEmployee()) {
            this.component = EmployeeDashboardView;
        } else if (this.$auth.isAdmin()) {
            this.component = AdminDashboardView;
        }
    }
}
</script>

<template>
    <component :is="component" v-if="component"/>
</template>
